import { OrganisationMin, LiteralUnion } from 'models';

import { API_URL } from 'config';
import { makeAPICall } from './api';
import {
    GroundStation,
    mapAPIToGroundStation,
    API as GS_API,
} from './groundstations';

export type Status = LiteralUnion<
    | 'idle'
    | 'inactive'
    | 'preparing'
    | 'executing'
    | 'testing'
    | 'error'
    | 'resetting'
>;

export declare namespace API {
    export interface Antenna {
        id: number;
        name: string;
        groundstation: GS_API.GroundStation;
        organisation: OrganisationMin;
        band_name: string;
        center_frequency: number;
        lon: number;
        lat: number;
        altitude: number;
        min_elevation: number;
        max_elevation: number;
        buffer_time: number;
        enabled: boolean;
        allow_partial_passes: boolean;
        percent_utilised: number;
        image: string;
        status: Status;
        created: string;
        last_known_elevation: number;
        last_known_azimuth: number;
        last_known_time: string;
        next_schedule: number | null;
    }
}

export interface Antenna {
    id: number;
    name: string;
    groundstation: GroundStation;
    organisation: OrganisationMin;
    band_name: string;
    center_frequency: number;
    lon: number;
    lat: number;
    altitude: number;
    min_elevation: number;
    max_elevation: number;
    buffer_time: number;
    enabled: boolean;
    allow_partial_passes: boolean;
    percent_utilised: number;
    image: string;
    status: Status;
    created: Date;
    lastKnownElevation: number;
    lastKnownAzimuth: number;
    lastKnownTime: Date;
    next_schedule: number | null;
}

const ANTENNAS_ROUTE = '/antennas';

export const mapAPIToAntenna = ({
    created,
    groundstation,
    last_known_azimuth,
    last_known_elevation,
    last_known_time,
    ...rest
}: API.Antenna): Antenna => ({
    ...rest,
    groundstation: mapAPIToGroundStation(groundstation),
    created: new Date(created),
    lastKnownAzimuth: last_known_azimuth,
    lastKnownElevation: last_known_elevation,
    lastKnownTime: new Date(last_known_time),
});

export const listAntennas = makeAPICall<
    Antenna[],
    void,
    { results: API.Antenna[] }
>(
    () => ({
        url: `${API_URL}${ANTENNAS_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToAntenna),
);

export const getAntenna = makeAPICall<Antenna, { id: number }, API.Antenna>(
    ({ id }) => ({
        url: `${API_URL}${ANTENNAS_ROUTE}/${id}/`,
    }),
    (antenna) => mapAPIToAntenna(antenna),
);
